var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuropeanWindowsIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5152_10637)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5152_10637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5152_10637",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V36H36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5152_10637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9799 19.9207H18.6148V30.7207C18.6148 32.3107 20.5948 33.0607 21.6448 31.8607L32.9998 18.9607C33.9898 17.8357 33.1948 16.0807 31.6948 16.0807H27.0598V5.28069C27.0598 3.69069 25.0798 2.94069 24.0298 4.14069L12.6749 17.0407C11.6999 18.1657 12.4949 19.9207 13.9799 19.9207Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.125H2.25C1.635 7.125 1.125 6.615 1.125 6C1.125 5.385 1.635 4.875 2.25 4.875H12.75C13.365 4.875 13.875 5.385 13.875 6C13.875 6.615 13.365 7.125 12.75 7.125Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 31.125H2.25C1.635 31.125 1.125 30.615 1.125 30C1.125 29.385 1.635 28.875 2.25 28.875H11.25C11.865 28.875 12.375 29.385 12.375 30C12.375 30.615 11.865 31.125 11.25 31.125Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 19.125H2.25C1.635 19.125 1.125 18.615 1.125 18C1.125 17.385 1.635 16.875 2.25 16.875H6.75C7.365 16.875 7.875 17.385 7.875 18C7.875 18.615 7.365 19.125 6.75 19.125Z",
    fill: "#FECB00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5152_10637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5152_10637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeanWindowsIcon1);
export default __webpack_public_path__ + "static/media/EuropeanWindowsIcon1.5a05879ba552cf4f1aaac8dfac200775.svg";
export { ForwardRef as ReactComponent };